import TextSummary from './TextSummary';

export default TextSummary;
